import React from 'react'
import { css } from '@emotion/react'
import HashLoader from 'react-spinners/HashLoader'

/**
 * Indicador de carga.
 *
 * Devuelve SÓLO el indicador, sin fila ni celda de tabla. Antes emitía su
 * propio <tr><td colSpan="100%">, y eso daba dos problemas:
 *
 *  · Los tres sitios que lo usan ya lo colocan dentro de un <td>, así que
 *    quedaba un <tr> dentro de un <td>. Eso es HTML inválido y el navegador
 *    lo saca de ahí por su cuenta, que es por lo que no se centraba.
 *  · colSpan="100%" no es un entero. La especificación pide un número, así
 *    que el atributo se descartaba y la celda ocupaba una sola columna.
 *
 * Colocarlo es responsabilidad de quien lo usa: dentro de una tabla, en un
 * <tr><td colSpan={n}>; fuera de una tabla, donde haga falta.
 */
const SpinnerLoading = ({ loading, size, color }) => {
  const centrado = css`
    display: block;
    margin: 0 auto;
  `

  return (
    <div style={{ textAlign: 'center', padding: '20px 0' }}>
      <HashLoader color={color} loading={loading} css={centrado} size={size} />
    </div>
  )
}

export default SpinnerLoading
